import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class BarcodeScannerService {

    async loadBarcodeScanner() {
        return {ScanResult: null};
    }
}